<template>
	<div class="login-container">
		<el-card class="login-card">
			<div class="login-header">
				<h2>邮箱群发系统</h2>
			</div>
			
			<el-tabs v-model="activeTab" @tab-click="handleTabClick">
				<el-tab-pane label="手机号登录" name="phone">
					<el-form ref="phoneLoginForm" :model="phoneLoginForm" :rules="phoneLoginRules" label-width="0">
						<el-form-item prop="phone">
							<el-input 
								v-model="phoneLoginForm.phone" 
								placeholder="请输入手机号"
								prefix-icon="el-icon-mobile-phone">
							</el-input>
						</el-form-item>
						
						<el-form-item prop="loginType">
							<el-radio-group v-model="phoneLoginForm.loginType">
								<el-radio label="code">验证码登录</el-radio>
								<el-radio label="password">密码登录</el-radio>
							</el-radio-group>
						</el-form-item>
						
						<el-form-item v-if="phoneLoginForm.loginType === 'code'" prop="code">
							<div class="code-input">
								<el-input 
									v-model="phoneLoginForm.code" 
									placeholder="请输入验证码"
									prefix-icon="el-icon-key">
								</el-input>
								<el-button 
									type="primary" 
									:disabled="codeCountdown > 0"
									@click="sendCode">
									{{ codeCountdown > 0 ? `${codeCountdown}s` : '发送验证码' }}
								</el-button>
							</div>
						</el-form-item>
						
						<el-form-item v-if="phoneLoginForm.loginType === 'password'" prop="password">
							<el-input 
								v-model="phoneLoginForm.password" 
								type="password" 
								placeholder="请输入密码"
								prefix-icon="el-icon-lock">
							</el-input>
						</el-form-item>
						
						<el-form-item>
							<el-button 
								type="primary" 
								class="login-btn" 
								:loading="logging"
								@click="handlePhoneLogin">
								登录
							</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				
				<el-tab-pane v-if="false" label="用户名登录" name="username">
					<el-form ref="usernameLoginForm" :model="usernameLoginForm" :rules="usernameLoginRules" label-width="0">
						<el-form-item prop="username">
							<el-input 
								v-model="usernameLoginForm.username" 
								placeholder="请输入用户名"
								prefix-icon="el-icon-user">
							</el-input>
						</el-form-item>
						
						<el-form-item prop="password">
							<el-input 
								v-model="usernameLoginForm.password" 
								type="password" 
								placeholder="请输入密码"
								prefix-icon="el-icon-lock">
							</el-input>
						</el-form-item>
						
						<el-form-item>
							<el-button 
								type="primary" 
								class="login-btn" 
								:loading="logging"
								@click="handleUsernameLogin">
								登录
							</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
			

		</el-card>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data() {
		return {
			activeTab: 'phone',
			phoneLoginForm: {
				phone: '',
				code: '',
				password: '',
				loginType: 'code'
			},
			usernameLoginForm: {
				username: 'admin',
				password: 'admin'
			},
			phoneLoginRules: {
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
					{ pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
				],
				loginType: [
					{ required: true, message: '请选择登录方式', trigger: 'change' }
				]
			},
			usernameLoginRules: {
				username: [
					{ required: true, message: '请输入用户名', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' }
				]
			},
			logging: false,
			codeCountdown: 0
		}
	},
	methods: {
		handleTabClick() {
			// 切换标签时重置表单
			this.$nextTick(() => {
				if (this.activeTab === 'phone') {
					this.$refs.phoneLoginForm?.resetFields();
				} else {
					this.$refs.usernameLoginForm?.resetFields();
				}
			});
		},
		
		async sendCode() {
			if (!this.phoneLoginForm.phone) {
				this.$message.warning('请先输入手机号');
				return;
			}
			
			if (!/^1[3-9]\d{9}$/.test(this.phoneLoginForm.phone)) {
				this.$message.warning('请输入正确的手机号');
				return;
			}
			
			try {
				const response = await this.$http.post('/api/auth/send-code', null, {
					params: {
						phone: this.phoneLoginForm.phone,
						type: 'login'
					}
				});
				
				this.$message.success('验证码发送成功');
				this.startCodeCountdown();
			} catch (error) {
				console.error('发送验证码失败:', error);
				const errorMsg = error.response?.data?.error || '发送验证码失败';
				this.$message.error(errorMsg);
			}
		},
		
		startCodeCountdown() {
			this.codeCountdown = 60;
			const timer = setInterval(() => {
				this.codeCountdown--;
				if (this.codeCountdown <= 0) {
					clearInterval(timer);
				}
			}, 1000);
		},
		
		async handlePhoneLogin() {
			this.$refs.phoneLoginForm.validate(async (valid) => {
				if (valid) {
					this.logging = true;
					try {
						const response = await this.$http.post('/api/auth/phone-login', this.phoneLoginForm);
						const { token, user, needSetPassword } = response.data;
						
						// 存储用户信息和token
						this.$store.commit('setUser', {
							id: user.id,
							username: user.username,
							email: user.email,
							phone: user.phone,
							token: token
						});
						
						// 设置axios默认header
						this.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
						
						this.$message.success('登录成功');
						this.$router.push('/dashboard');
					} catch (error) {
						console.error('登录失败:', error);
						const errorMsg = error.response?.data?.error || '登录失败';
						this.$message.error(errorMsg);
					} finally {
						this.logging = false;
					}
				}
			});
		},
		
		async handleUsernameLogin() {
			this.$refs.usernameLoginForm.validate(async (valid) => {
				if (valid) {
					this.logging = true;
					try {
						const response = await this.$http.post('/api/auth/login', this.usernameLoginForm);
						const { token, user } = response.data;
						
						// 存储用户信息和token
						this.$store.commit('setUser', {
							id: user.id,
							username: user.username,
							email: user.email,
							phone: user.phone,
							token: token
						});
						
						// 设置axios默认header
						this.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
						
						this.$message.success('登录成功');
						this.$router.push('/dashboard');
					} catch (error) {
						console.error('登录失败:', error);
						const errorMsg = error.response?.data?.error || '登录失败';
						this.$message.error(errorMsg);
					} finally {
						this.logging = false;
					}
				}
			});
		},
		
		goToRegister() {
			this.$router.push('/register');
		}
	}
}
</script>

<style scoped>
.login-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-card {
	width: 400px;
	border-radius: 8px;
	box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.login-header {
	text-align: center;
	margin-bottom: 30px;
}

.login-header h2 {
	color: #303133;
	margin-bottom: 10px;
}

.login-header p {
	color: #909399;
	margin: 0;
}

.code-input {
	display: flex;
	gap: 10px;
}

.code-input .el-input {
	flex: 1;
}

.code-input .el-button {
	width: 120px;
}

.login-btn {
	width: 100%;
}

.login-tips {
	text-align: center;
	margin-top: 20px;
	padding-top: 20px;
	border-top: 1px solid #ebeef5;
}

.login-tips p {
	color: #909399;
	margin: 0;
}
</style> 